import { useState, useCallback } from "react"
import { useTranslation } from "react-i18next"
import { IconBellPlus } from "@tabler/icons-react"
import { ReminderInputModal } from "@/routes/-components/reminders/reminder-input-modal"

export function useGetNewReminderMenuItemProps() {
  const { t } = useTranslation("app_server")
  const [opened, setOpened] = useState(false)

  const handleOpen = useCallback(() => setOpened(true), [])
  const handleClose = useCallback(() => setOpened(false), [])

  const menuItem = {
    children: t("NewReminder") as string,
    leftSection: <IconBellPlus size={16} />,
    onClick: handleOpen,
  }

  const modal = <ReminderInputModal opened={opened} onClose={handleClose} />

  return { menuItem, modal }
}
